import { useEffect } from 'react'

import { AreaSelect } from '@/modules/Areas/ui/AreasSelect'
import { RecordsType } from '@/types/performanceManager'
import { UnfinishedRecordsTable } from './components/performanceManager/UnfinishedRecordsTable'
import { UpdatedRecordsTable } from './components/UpdatedRecordsTable'
import { Tabs } from '@/ui/Tabs'
import { usePMUnfinishedRecordsStore } from '../store'

import commonStyles from './UnfinishedRecords.module.scss'
import styles from './PerformanceManagerUnfinishedRecords.module.scss'

const options = [
    {
        label: 'Unfinished',
        value: RecordsType.Unfinished,
    },
    {
        label: 'Updated',
        value: RecordsType.Updated,
    },
]

export const PerformanceManagerUnfinishedRecords = () => {
    const { selectedType, setSelectedType } = usePMUnfinishedRecordsStore()

    useEffect(() => {
        return () => {
            setSelectedType(RecordsType.Unfinished)
        }
    }, [])

    return (
        <section className={commonStyles.root}>
            <header className={commonStyles.header}>
                <AreaSelect />
            </header>
            <div className={commonStyles.container}>
                <div className={styles.content}>
                    <Tabs options={options} onChange={(type) => setSelectedType(type as RecordsType)} />
                    {selectedType === RecordsType.Unfinished && <UnfinishedRecordsTable />}
                    {selectedType === RecordsType.Updated && <UpdatedRecordsTable />}
                </div>
            </div>
        </section>
    )
}
